import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'

const commonClasses = `flex items-center justify-center leading-snug px-32 text-center no-underline`

export const ButtonLink = ({ className, children, ...rest }) => (
  <Link className={cx(commonClasses, className, 'py-20')} {...rest}>
    {children}
  </Link>
)

export const ButtonLinkSmall = ({ className, children, ...rest }) => (
  <Link className={cx(commonClasses, className, 'py-12')} {...rest}>
    {children}
  </Link>
)

export const ExternalLink = ({ className, children, ...rest }) => (
  <a className={cx(commonClasses, className, 'py-20')} {...rest}>
    {children}
  </a>
)

export const Button = ({ className, children, ...rest }) => (
  <button className={cx(commonClasses, className, 'py-20')} {...rest}>
    {children}
  </button>
)

export const ButtonSmall = ({ className, children, ...rest }) => (
  <button className={cx(commonClasses, className, 'py-12')} {...rest}>
    {children}
  </button>
)
